import { DatePipe, DecimalPipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api'; // Importa este servicio
import { ConfirmDialogModule } from 'primeng/confirmdialog'; // Importa este módulo
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import { CustomModalComponent } from './components/custom-modal/custom-modal.component';
import { CustomProgressSpinnerComponent } from './components/custom-progress/custom-progress-spinner/custom-progress-spinner.component';
import { HeaderComponent } from './components/header/header.component';
import { NewBreadcrumb } from './components/new-breadcrumb/new-breadcrumb.component';
import { NewMenuComponent } from './components/new-menu/new-menu.component';
import { GeneralInterceptor } from './interceptors/general-interceptor';
import { LoginService } from './services/authentication/login.service';
import { UpdatePasswordComponent } from './views/authentication/users/update-password/update-password.component';
import { HomeComponent } from './views/components/home/home.component';
import { ViewModule } from './views/view.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
  ],
  imports: [
    NewBreadcrumb,
    BrowserModule,
    AppRoutingModule,
    NewMenuComponent,
    FormsModule,
    UpdatePasswordComponent,
    HeaderComponent,
    HttpClientModule, // TODO change to new implementation
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ViewModule,
    ComponentsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    ConfirmDialogModule,
    ReactiveFormsModule,
    MultiSelectModule,
    TableModule,
    CustomProgressSpinnerComponent,
    CustomModalComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GeneralInterceptor,
      multi: true,
    },
    ConfirmationService,
    LoginService,
    DatePipe,
    DecimalPipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
